import { useRef, useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export const TextEditor = ({ value, onChange, placeholder="Write your content here..."}) => {
    const quillRef = useRef(null);

    const linkHandler = function () {
        const range = this.quill.getSelection();
        if (range) {
            const url = prompt('Enter URL:');
            if (url) {
                let formattedUrl = url.trim();
                // Check if URL already has a protocol
                if (!formattedUrl.match(/^https?:\/\//i)) {
                    formattedUrl = `https://${formattedUrl}`;
                }
                this.quill.format('link', formattedUrl);
            }
        }
    }

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['link', 'image'],
                [{ 'align': [] }],
                [{ 'color': [] }, { 'background': [] }],
                ['clean']
            ],
            handlers: {
                link: linkHandler
            }
        }
    }), []);

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image',
        'align', 'color', 'background',
    ];

    return (
        <div className="mb-4">
            Content:
            <label htmlFor="content" className="block text-sm font-medium text-gray-700 mb-1">
              
            </label>
            <div className="text-editor">
                <ReactQuill
                    ref={quillRef}
                    theme="snow"
                    value={value}
                    onChange={onChange}
                    modules={modules}
                    formats={formats}
                    placeholder={placeholder}
                    style={{ minHeight: '200px' }}
                />
                <div className="h-10"></div>
            </div>
        </div>
    );
}

export default TextEditor;